import React from 'react'
import BigCalendar from 'react-big-calendar'
import moment from 'moment'
import { Query } from 'react-apollo'
import TextField from 'material-ui/TextField'

// graphql
import miniMe from 'graphql/queries/miniMe'
import utente from 'graphql/queries/utente'
import agenti from 'graphql/queries/agenti'

// core components
import GridContainer from 'components/Grid/GridContainer.jsx'
import ItemGrid from 'components/Grid/ItemGrid.jsx'
import RegularCard from 'components/Cards/RegularCard.jsx'
import CalendarModalForm from 'components/CalendarModalForm/CalendarModalForm'

import { MenuItem } from 'material-ui/Menu'

// css
import 'react-big-calendar/lib/css/react-big-calendar.css'
import './Calendario.css'

BigCalendar.momentLocalizer(moment)


class Calendario extends React.Component {
  constructor(props) {
    super(props)

    // Voglio l'ora su 24 ore
		let timeRangeFormat = ({ start, end }, culture, local) =>
    local.format(start, 'HH:mm', culture) +
    ' - ' + local.format(end, 'HH:mm', culture)

    let dayHeaderFormat = (Date, culture, local) =>
    local.format(Date, 'ddd DD MMMM', culture)

    let weekHeaderFormat = ({ start, end }, culture, local) => {
      if (local.format(start, 'M', culture) === local.format(end, 'M', culture)) {
        return (
          local.format(start, 'DD', culture) +
          ' - ' + local.format(end, 'DD MMMM', culture)
        )
      }
      return (
        local.format(start, 'DD MMMM', culture) +
        ' - ' + local.format(end, 'DD MMMM', culture)
      )
    }

    const showMoreMessage = additionalMessages => {
      return (
        <span>+ altri {additionalMessages}</span>
      )
    }

    this.state = {
      eventsType: 'calendar',
      showModal: false,
      initialValues: {},
      isNewEvent: true,
      utenteId: '',
      error: '',
      dataCorrente: moment().format('YYYY-MM-DD'),
      messages: {
        date: 'Data',
        time: 'Ora',
        event: 'Appuntamento',
        allDay: 'Tutto il giorno',
        previous: '<',
        next: '>',
        today: 'Oggi',
        month: 'Mese',
        week: 'Settimana',
        day: 'Giorno',
        agenda: 'Agenda',
        showMore: showMoreMessage
      },
      formats: {
        selectRangeFormat: timeRangeFormat,
        agendaTimeFormat: timeRangeFormat,
        agendaTimeRangeFormat: timeRangeFormat,
        dayRangeHeaderFormat: weekHeaderFormat,
        dayHeaderFormat: dayHeaderFormat
      }
    }
  }

  closeModal = () => {
    this.setState({
      showModal: false,
      initialValues: {},
      error: ''
    })
  }

  setUtenteId = myId => event => {
    this.setState({
      utenteId: event.target.value || myId
    })
  }

  setErrorMessage = errorMessage => {
    this.setState({
      error: errorMessage
    })
  }

  addNewEventAlert(slotInfo, utenteId, ruolo, isMyCalendar) {
    const initialValues = {
      tipoEvento: (ruolo === 'AGENTE' && !isMyCalendar) ? 'appuntamento' : '',
      start: moment(slotInfo.start).toDate(),
      end: moment(slotInfo.end).toDate(),
      agenteId: utenteId,
      clienteId: '',
      luogo: '',
      appuntamentoOrigine:'',
      stato: 'FISSATO_AGENTE',
      descrizione: '',
      title: ''
    }
    
    this.setState({
      showModal: true,
      initialValues: initialValues,
      isNewEvent: true
    })
  }

  selectedEvent(evento) {
    const initialValues = {
      id: evento.id,
      tipoEvento: evento.tipoEvento,
      start: evento.start,
      end: evento.end,
      agenteId: evento.agenteId,
      clienteId: evento.clienteId,
      luogo: evento.luogo,
      stato: evento.stato,
      appuntamentoOrigine:evento.appuntamentoOrigine,
      descrizione: evento.descrizione,
      title: evento.title
    }
    
    this.setState({
      showModal: true,
      initialValues: initialValues,
      isNewEvent: false
    })
  }

  eventColors(evento) {
    let backgroundColor = "#ccc"

    switch (evento.tipoEvento.toLowerCase()) {
      case 'appuntamento':
        switch (evento.stato.toUpperCase()) {
          case 'FISSATO_AGENTE':
            backgroundColor = '#ff9800'
            break
          case 'CONFERMATO_SEGRETARIA':
            backgroundColor = '#00bcd4'
            break
          case 'CONFERMATO_CLIENTE':
            backgroundColor = '#0476be'
            break
          case 'ANNULLATO_CLIENTE':
            backgroundColor = '#e83f3f'
            break
          case 'SALTATO':
            backgroundColor = '#e83f3f'
            break
          case 'FATTO':
            backgroundColor = '#85ce1a'
            break
          default:
            break
        }
        break
      // case 'proposta acquisto':
      // case 'preliminare':
      //   backgroundColor = '#5a89a6'
      //   break
      case 'assenza-occupato':
        backgroundColor = '#999'
        break
      case 'assenza-fuori-sede':
        backgroundColor = '#a43fb5'
        break
      default:
        break
    }

    return {
      style: { backgroundColor }
    }
  }

  tipoEvento(tipoAzione, assenzaIsOccupato) {
    if (!!tipoAzione) {
      return tipoAzione.tipo
    }
    if (!!assenzaIsOccupato) {
      return 'assenza-occupato'
    }
    return 'assenza-fuori-sede'
  }

  titoloEvento(tipoAzione, nomeCliente, descrizione, assenzaIsOccupato) {
    if (!!tipoAzione) {
      return nomeCliente
    }
    if (!!descrizione) {
      return descrizione
    } else {
      if (!!assenzaIsOccupato) {
        return 'Assente (occupato)'
      }
      return 'Assente (fuori sede)'
    }
  }

  handleNavigate = date => {
    this.setState({
      dataCorrente: moment(date).format('YYYY-MM-DD HH:mm')
    })
  }


  render() {
    const { eventsType, showModal, initialValues, isNewEvent, messages, formats } = this.state

    return (
      <div className="calendario">
        <GridContainer justify="center">
          <ItemGrid xs={12} sm={10}>
            <Query query={miniMe}>
              {({ loading, error, data: { me } }) => {
                if (loading) return <p>Loading...</p>
                if (error) return <p>Error :(</p>
                
                const startOfMonth = moment(this.state.dataCorrente).startOf('month').subtract(7, 'days').format('YYYY-MM-DD')
                const endOfMonth = moment(this.state.dataCorrente).endOf('month').add(7, 'days').format('YYYY-MM-DD')

                return (
                  <div>
                    <Query 
                      query={utente}
                      variables={{ 
                        where: {
                          id: !!this.state.utenteId ? parseInt(this.state.utenteId) : parseInt(me.id, 10)
                        },
                        appuntamentiWhere: {
                          OR: [
                            {
                              appuntamentoDaDataOra_gte: startOfMonth,
                              appuntamentoDaDataOra_lte: endOfMonth
                            },
                            {
                              appuntamentoADataOra_gte: startOfMonth,
                              appuntamentoADataOra_lte: endOfMonth
                            },
                            {
                              appuntamentoDaDataOra_lte: startOfMonth,
                              appuntamentoADataOra_gte: endOfMonth
                            }
                          ]
                        },
                        assenzeWhere: {
                          OR: [
                            {
                              daDataOra_gte: startOfMonth,
                              daDataOra_lte: endOfMonth
                            },
                            {
                              aDataOra_gte: startOfMonth,
                              aDataOra_lte: endOfMonth
                            },
                            {
                              daDataOra_lte: startOfMonth,
                              aDataOra_gte: endOfMonth
                            }
                          ]
                        }
                      }}
                      fetchPolicy="cache-and-network"
                    >
                      {({ loading, error, data }) => {
                        if (loading) return <p>Loading...</p>
                        if (error) return <p>Error :(</p>

                        const assenze = data.utente.assenze
                        const appuntamenti = data.utente.appuntamenti
                        const utenteId = me.ruolo === 'AGENTE' ? data.utente.id : this.state.utenteId
                        
                        const eventi = [...assenze, ...appuntamenti]

                        const eventiCalendario = eventi.map(e => {
                          // console.log(e)

                          const appuntamentoDaDataOra = e.appuntamentoDaDataOra && moment(e.appuntamentoDaDataOra, 'YYYY-MM-DD HH:mm').toDate()
                          const appuntamentoADataOra = e.appuntamentoADataOra && moment(e.appuntamentoADataOra, 'YYYY-MM-DD HH:mm').toDate()
                          const assenzaDaDataOra = e.daDataOra && moment(e.daDataOra, 'YYYY-MM-DD HH:mm').toDate()
                          const assenzaADataOra = e.aDataOra && moment(e.aDataOra, 'YYYY-MM-DD HH:mm').toDate()

                          const isAppuntamentoAllDay = e.appuntamentoDaDataOra && (appuntamentoDaDataOra.toString().indexOf('00:00:00') > 0 && appuntamentoADataOra.toString().indexOf('00:00:00') > 0 ? true : false)
                          const isAssenzaAllDay = e.daDataOra && (assenzaDaDataOra.toString().indexOf('00:00:00') > 0 && assenzaADataOra.toString().indexOf('00:00:00') > 0 ? true : false)

                          return ({
                            id: e.id,
                            tipoEvento: this.tipoEvento(e.tipoAzione, e.flagOccupato),
                            title: this.titoloEvento(e.tipoAzione, e.cliente && e.cliente.nome, e.descrizione, e.flagOccupato),
                            allDay: e.tipoAzione ? isAppuntamentoAllDay : isAssenzaAllDay,
                            start: e.tipoAzione ? appuntamentoDaDataOra : assenzaDaDataOra,
                            end: e.tipoAzione ? appuntamentoADataOra : assenzaADataOra,
                            agenteId: e.tipoAzione ? e.appuntamentoAgente.id : e.utenteId,
                            clienteId: e.cliente ? e.cliente.id : null,
                            luogo: e.appuntamentoLuogo ? e.appuntamentoLuogo : null,
                            appuntamentoOrigine:e.appuntamentoOrigine ? e.appuntamentoOrigine : null,
                            stato: e.appuntamentoStato ? e.appuntamentoStato : null,
                            descrizione: e.descrizione,
                          })
                        })
                        // console.log("eventiCalendario: ", eventiCalendario)
                        
                        const isMyCalendar = me.id === utenteId
                        //console.log(me.ruolo, me.id, utenteId, isMyCalendar)

                        return (
                          <div>
                            <RegularCard
                              content={
                                <div>
                                  <Query
                                    query={agenti}
                                    variables={{
                                      limit: 50,
                                    }}
                                  >
                                    {({ loading, error, data }) => {
                                      if (loading) return <p>Loading...</p>
                                      if (error) return <p>Error :(</p>
  
                                      const options = data.utenti.nodes.map(agente => ({
                                        value: agente.id,
                                        label: agente.nome,
                                      }))
  
                                      return (
                                        <GridContainer>
                                          <ItemGrid xs={12} md={4}>
                                            <TextField
                                              id="utenteId"
                                              label="Agente"
                                              className="user-calendar-select"
                                              select
                                              fullWidth
                                              value={me.ruolo === 'AGENTE' ? (utenteId || me.id) : utenteId}
                                              onChange={this.setUtenteId(me.id)}
                                            >
                                              {options && options.map(option => {
                                                return (
                                                  <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                                                )
                                              })
                                              }
                                            </TextField>
                                          </ItemGrid>
                                        </GridContainer>
                                      )
                                    }}
                                  </Query>
                                  
                                  {(!!utenteId || me.ruolo === 'AGENTE') &&
                                    <BigCalendar
                                      date={moment(this.state.dataCorrente).toDate()}
                                      selectable
                                      popup
                                      events={eventiCalendario}
                                      defaultView="month"
                                      messages={messages}
                                      formats={formats}
                                      scrollToTime={new Date(2018, 1, 1)}
                                      defaultDate={new Date()}
                                      onSelectEvent={(me.ruolo === 'ADMIN' || me.ruolo === 'SEGRETARIA' || (me.ruolo === 'AGENTE' && !!isMyCalendar)) && (evento => this.selectedEvent(evento))}
                                      onSelectSlot={slotInfo => this.addNewEventAlert(slotInfo, utenteId, me.ruolo, isMyCalendar)}
                                      eventPropGetter={this.eventColors}
                                      views={['month', 'week', 'day']}
                                      onNavigate={this.handleNavigate}
                                    />
                                  }
                                </div>
                              }
                            />

                            <CalendarModalForm
                              eventsType={eventsType}
                              initialValues={initialValues}
                              agenteId={initialValues.agenteId}
                              isNewEvent={isNewEvent}
                              open={!!showModal}
                              onCloseModal={this.closeModal}
                              onSetErrorMessage={this.setErrorMessage}
                              isAgente={me.ruolo === 'AGENTE'}
                              isMyCalendar={!!isMyCalendar}
                            />
                          </div>
                        )
                      }}
                    </Query>
                  </div>
                )
              }}
            </Query>
          </ItemGrid>
        </GridContainer>
      </div>
    )
  }
}

export default Calendario


// WEBPACK FOOTER //
// ./src/views/App/Calendario/Calendario.jsx